<template>
    <div class="vx-row">
        <div class="vx-col w-2/3">
            <vs-card>
                <div slot="header" class="vx-row">
                    <v-select v-model="company" :options="companies" label="name" class="vx-col w-full pb-4" />
                    <vs-input v-model="search" class="vx-col w-full" />
                </div>
                <vs-list>
                    <vs-list-item v-for="product in searchedProducts" :key="product.id" :title="product.name" :subtitle="getProductPrice(product)">
                        <vs-button radius color="primary" type="filled" icon="add_shopping_cart" @click="checkIfProductHasAddon(product)" />
                    </vs-list-item>
                </vs-list>
            </vs-card>
        </div>
        <div class="vx-col w-1/3">
            <ht-cart
                :company_name="company.name"
                :company_slug="company.slug"
                :company_status="company.status"
                :discounts="discounts"
                :delivery_fees="delivery_fees"
                :delivery_fee="delivery_fee"
                :postcode="postal_code"
                :paymentMethods="paymentMethods"
            ></ht-cart>
            <vs-button class="w-full mb-6" @click="toggleCheckout()">Aanmaken</vs-button>
        </div>
        <vs-popup :active.sync="productPopup" :title="productPopupData.name" v-if="productPopupData">
            <ht-list-item-addon-category v-for="addonCat in productPopupData.addon_categories" :key="addonCat.id" :addon-cat="addonCat" :product_id="productPopupData.id" :name="addonCat.name" />
            <vs-button class="float-right mt-4" color="primary" type="filled" icon="add_shopping_cart" @click="checkIfProductHasAddon(productPopupData)">Voeg toe aan winkelwagen</vs-button>
        </vs-popup>
        <vs-popup :active.sync="checkoutPopup" title="Informatie">
            <div class="vx-row">
                <vs-input placeholder="Voornaam" v-model="firstname" class="v-col w-1/3 pl-4 pr-4 py-2"/>
                <vs-input placeholder="tussenvoegsel" v-model="insertion" class="v-col w-1/3 pr-4 py-2"/>
                <vs-input placeholder="Achternaam" v-model="lastname" class="v-col w-1/3 pr-4 py-2"/>
                <vs-input placeholder="Email" v-model="email" class="v-col w-1/2 pl-4 pr-4 py-2"/>
                <vs-input placeholder="Telefoonnummer" v-model="phonenumber" class="v-col w-1/2 pr-4 py-2"/>
                <vs-input placeholder="Postcode" v-model="postal_code" class="v-col w-1/2 pl-4 pr-4 py-2"/>
                <vs-input placeholder="Huisnummer" v-model="housenumber" class="v-col w-1/2 pr-4 py-2"/>
                <vs-input placeholder="Straatnaam" v-model="streetname" :disabled="streetnamedisabled" class="v-col w-1/2 pl-4 pr-4 py-2"/>
                <vs-input placeholder="Stad" v-model="city" :disabled="citydisabled" class="v-col w-1/2 pr-4 py-2"/>
                <vs-textarea placeholder="Opmerking" v-model="note" class="v-col w-full mx-4 my-2"></vs-textarea>
                <div class="v-col w-1/2 py-2 pl-4">
                    <label for="">Bezorgkosten?</label>
                    <vs-switch v-model="applyDeliveryFee" />
                </div>
                <div class="v-col w-1/2 pr-4 pl-4">
                    <div class="text-right mt-4">
                        <strong>Totaal bedrag: € {{ totalPrice }}</strong>
                    </div>
                    <vs-button class="float-right mt-4" color="primary" @click="procesOrder()"><b>Verstuur</b></vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import cart from "../../../components/cart/Cart"
import HtListItemAddonCategory from "../../../components/order/ListItemAddonCategory"

export default {
    components: {
        'ht-cart': cart,
        HtListItemAddonCategory
    },
    mounted() {
        this.getCompanies()
        this.$events.listen('updatedCart', (cart) => {
            this.setCart(cart)
        });
        this.$events.listen('total_price', (event) => {
            this.total_price = event
        });
        this.$events.listen('addAddon', this.addAddon);
        this.$events.listen('addAddonWithMultiple', this.addAddonWithMultiple);
    },
    data() {
        return {
            search: '',
            company: {},
            paymentMethod: '',
            paymentMethods: [],
            companies: [],
            products: [],
            productAddons: [],
            addon_categories: [],
            delivery_fees: [],
            discounts: [],
            checkoutPopup: false,
            productPopup: false,
            total_price: "",
            productNote: "",
            productPopupData: null,
            firstname: "",
            insertion: "",
            lastname: "",
            email: "",
            phonenumber: "",
            streetname: "",
            streetnamedisabled: true,
            housenumber: "",
            postal_code: "",
            city: "",
            citydisabled: true,
            note: "",
            applyDeliveryFee: false,
            cart: []
        }
    },
    watch: {
        company: function() {
            this.getProducts()
            this.getDeliveryFees()
            this.getDiscounts()
            this.getCart()
        },
        productPopup: function() {
            if(this.productPopup == false) {
                this.productAddons = [];
            }
        },
        housenumber: function () {
            this.getAdress();
        },
    },
    computed: {
        searchedProducts() {
            return this.products.filter((product) => {
                var upperCaseProduct = product.name.toUpperCase()
                return upperCaseProduct.match(this.search.toUpperCase())
            })
        },
        delivery_fee: function() {
            if(this.applyDeliveryFee == true) {
                for( let i in this.delivery_fees ) {
                    if( this.delivery_fees[i].location.postal_code.includes(this.postal_code.toUpperCase())) {
                        return Number(this.delivery_fees[i].fee);
                    }
                }
            } else {
                return 0
            }
        },
        totalPrice: function() {
            if(this.delivery_fee !== undefined) {
                return this.total_price + this.delivery_fee
            } else {
                return this.total_price
            }
        }
    },
    methods: {
        getCart: function() {
            if (localStorage.getItem("cart-" + this.company.slug)) {
                this.cart = JSON.parse(localStorage.getItem("cart-" + this.company.slug));
            }
        },
        setCart: function(cart) {
            console.log(cart);
            this.cart = cart
        },
        toggleCheckout: function() {
            if(this.checkoutPopup) {
                this.checkoutPopup = false
            } else {
                this.checkoutPopup = true
            }
        },
        getProductPrice(product) {
            return '€ '+product.price
        },
        checkIfAddonSelected: function(addon) {
            var checked = false;
            this.productAddons.map((add) => {
                if (add.id == addon.id) {
                    checked = true;
                }
            });

            return checked;
        },
        addAddon: function (newAddon) {
            if(this.productAddons.length > 0) {
                for(var i = 0; i < this.productAddons.length; i++) {
                    if(this.productAddons[i].company_product_addon_category_id == newAddon.company_product_addon_category_id) {
                        this.productAddons.splice(i, 1);
                        this.productAddons.push(newAddon);
                    } else {
                        this.productAddons.push(newAddon);
                    }
                }
            } else {
                this.productAddons.push(newAddon);
            }
        },
        addAddonWithMultiple: function (newAddon) {
            var push = false;
            this.productAddons.map((addon) => {
                if(addon.id !== newAddon.id) {
                    push = true;
                    return;
                }
            })
            if(push) {
                this.productAddons.push(newAddon);
            }
        },
        checkIfProductHasAddon: function(product) {
            if( product.addon_categories.length === 0 ) {
                this.productPopup = false
                // Emit global event with product data
                this.fireProductPushedToCartEvent(product);
            } else {
                this.openAddon(product);
            }
        },
        openAddon: function(product) {
            if( this.productPopup === false ) {
                this.productPopup = true;
                this.productPopupData = product;
                product.addon_categories.map(addoncategory => {
                    if(!addoncategory.multiple) {
                        this.productAddons.push(addoncategory.addons[0])
                    }
                })
            } else {
                // Emit global event with product data
                this.fireProductPushedToCartEvent(product);
                this.productPopup = false
                this.productAddons = [];
            }
        },
        fireProductPushedToCartEvent: function(product) {
            this.$events.fire('productPushedToCart', {
                uuid: this.setUuid(product),
                id: product.id,
                cat_id: product.category.id,
                name: product.name,
                description: product.description,
                price: product.price,
                sale_price: product.sale_price,
                quantity: 1,
                total_price: product.total_price,
                addons: this.productAddons,
                note: this.productNote
            });
        },
        setUuid: function(product) {
            var addon_id = product.id;
            for (let i in this.productAddons) {
                addon_id += '_' + this.productAddons[i].id;
                addon_id += '_' + this.productAddons[i].cat_id;
            }
           return addon_id;
        },
        getCompanies() {
            return this.$http.get('/v1/companies/list', {
                headers: {
                    Authorization: 'Bearer ' + this.$auth.token
                }
            }).then((response) => {
                this.companies = response.data.data
                this.company = this.companies[0]
                if (localStorage.getItem("cart-" + this.company.slug)) {
                    this.cart = JSON.parse(localStorage.getItem("cart-" + this.company.slug));
                }
            }).catch((error) => {
                this.$util.logError(error, this.$vs)
            });
        },
        getProducts() {
            this.$http.get('/v1/company/'+ this.company.slug + '/products-with-addons', {
                headers: {
                    Authorization: 'Bearer ' + this.$auth.token
                }
            }).then((response) => {
                this.products = response.data.data
            }).catch((error) => {
                this.$util.logError(error, this.$vs)
            });
        },
        getDeliveryFees() {
            this.$http.get('/v1/company/'+ this.company.slug + '/locations-with-fees', {
                headers: {
                    Authorization: 'Bearer ' + this.$auth.token
                }
            }).then((response) => {
                this.delivery_fees = response.data
            }).catch((error) => {
                this.$util.logError(error, this.$vs)
            });
        },
        getDiscounts() {
            this.$http.get('/v1/company/'+ this.company.slug + '/discounts', {
                headers: {
                    Authorization: 'Bearer ' + this.$auth.token
                }
            }).then((response) => {
                this.$vs.notify({
                    text: response.data.message,
                    type: "success"
                });
            }).catch((error) => {
                this.$util.logError(error, this.$vs)
            });
        },
        procesOrder() {
            this.$http.post('/v1/company/'+ this.company.slug + '/order/create', {
                phone_number: this.phonenumber,
                postal_code: this.postal_code,
                streetname: this.streetname,
                city: this.city,
                housenumber: this.housenumber,
                firstname: this.firstname,
                insertion: this.insertion,
                lastname: this.lastname,
                email: this.email,
                applyDeliveryFee: this.applyDeliveryFee,
                company_id: this.company.id,
                note: this.note,
                delivery_time: 'Zo snel mogelijk',
                delivery_fee: 0,
                cart: this.cart
            }, {
                headers: {
                    Authorization: 'Bearer ' + this.$auth.token
                }
            }).then((response) => {
                this.checkoutPopup = false;
                this.$vs.notify({
                    text: response.data.message,
                    type: "success"
                });
            }).catch((error) => {
                this.$util.logError(error, this.$vs)
            });
        },
        getAdress: function() {
            var housenumber = this.housenumber;
            var patt = new RegExp(/^[^\d]*(\d+)/);
            var housenumber = patt.exec(housenumber);
            this.$http.get('https://api.hebtrek.nl/checkout/check-postcode', {
                params: {
                    'postcode': this.postal_code,
                    'housenumber': housenumber[0]
                },
                headers: {
                    'Authorization': 'Bearer exs0ivXWIrcglC5Gxkoq06atlFcfpzR34yGYiuZFJNHXCfl8lh67MibspoT0'
                }
            })
            .then((response) => {
                console.log(response.data);
                this.streetname = response.data.street;
                this.city = response.data.city;
            })
            .catch((error) => {
                console.log(error);
                this.streetnamedisabled = false
                this.citydisabled = false
            });
        },
    }
}
</script>

<style>

</style>
